"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionToJSX = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const optionToJSX = (translationWeek) => (option) => {
    return ((0, jsx_runtime_1.jsx)("option", { value: option.id, children: `${translationWeek} ${option.week}` }, `${option.id}`));
};
exports.optionToJSX = optionToJSX;
//# sourceMappingURL=SelectOptionsToJSX.js.map